import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@mui/material';

import MoreVertIcon from '../../../../assets/icons/MoreVertIcon';

const RosterCardMoreButton = ({ onClick, ariaLabel = 'More options' }) => (
  <IconButton
    aria-label={ariaLabel}
    onClick={onClick}
    sx={{ '&:hover': { backgroundColor: 'transparent' } }}
  >
    <MoreVertIcon />
  </IconButton>
);

RosterCardMoreButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default RosterCardMoreButton;
